module.exports.skipTokens = {
  global: {
    aubergine10: '#e7d6e7',
    aubergine80: '#452844',
    berry10: '#ffe7eb',
    berry90: '#622d35',
    black: '#000',
    blue: '#125fca',
    blue10: '#ebf6fa',
    blue25: '#c1dade',
    blue30: '#7aadf6',
    blue70: '#094dac',
    blue90: '#083343',
    blueDarkHc: '#1054b4',
    blueLightHc: '#8bbcfe',
    charcoal30: '#d7d9da',
    charcoal40: '#b7bdbe',
    charcoal50: '#8c999b',
    charcoal57: '#68797d',
    charcoal60: '#5d7074',
    charcoal70: '#3c4c4f',
    charcoal75: '#303d3f',
    charcoal80: '#242e30',
    cupcake10: '#e7f4f6',
    cupcake90: '#254043',
    green: '#017a39',
    green10: '#e5faef',
    green30: '#22bf65',
    green90: '#273f33',
    greenDarkHc: '#196634',
    greenLightHc: '#26d46e',
    mozzarella10: '#f5f3f1',
    mozzarella100: '#1a1a19',
    mozzarella20: '#efedea',
    mozzarella30: '#dbd9d7',
    mozzarella5: '#fcfcfc',
    mozzarella50: '#9e9c9a',
    mozzarella55: '#8B8A88',
    mozzarella60: '#797876',
    mozzarella70: '#575655',
    mozzarella75: '#494847',
    mozzarella80: '#3b3a39',
    mozzarella90: '#262626',
    orange: '#f36805',
    orange10: '#ffead4',
    orange30: '#ff8000',
    orange55: '#f75e28',
    orange90: '#41301f',
    orangeDarkHc: '#a33100',
    purple: '#5b3d5b',
    purpleLightHc: '#ba98ba',
    red: '#d50525',
    red10: '#ffe9ea',
    red25: '#f2a6b0',
    red30: '#f68179',
    red40: '#e22c3e',
    red90: '#491e24',
    redDarkHc: '#a4041f',
    redLightHc: '#ff7a80',
    systemPurple: '#800080',
    systemPurple10: '#c58af9',
    tomato5: '#ffd3bf',
    tomato90: '#622b18',
    turmeric5: '#fff9de',
    turmeric60: '#bf8b09',
    turmeric80: '#745300',
    white: '#fff',
    yellow: '#f6c243',
    yellow10: '#fff9df',
    yellow90: '#474630',
    yellowDarkHc: '#685731',
  },
  font: {
    familyCode: 'PTMono',
    familyPrimary: 'JetSansDigital',
    familySecondary: 'Arial',
    paragraphSpacing01: '16px',
    paragraphSpacing02: '14px',
    paragraphSpacing03: '12px',
    size12: { fontSize: '12px', lineHeight: '16px' },
    size14: { fontSize: '14px', lineHeight: '20px' },
    size16: { fontSize: '16px', lineHeight: '24px' },
    size20: { fontSize: '20px', lineHeight: '28px' },
    size24: { fontSize: '24px', lineHeight: '32px' },
    size28: { fontSize: '28px', lineHeight: '36px' },
    size32: { fontSize: '32px', lineHeight: '40px' },
    size48: { fontSize: '48px', lineHeight: '56px' },
    styleUnderline: 'underline',
    weightBold: '700',
    weightExtrabold: '800',
    weightRegular: '400',
  },
  alias: {
    light: {
      backgroundDefault: '#fcfcfc',
      backgroundSubtle: '#f5f3f1',
      backgroundDark: '#1a1a19',
      containerDefault: '#fff',
      containerSubtle: '#f5f3f1',
      containerStrong: '#efedea',
      containerDark: '#262626',
      containerLight: '#fff',
      containerInverse: '#262626',
      containerInverseAlternative: '#262626',
      borderDefault: '#efedea',
      borderSubtle: '#f5f3f1',
      borderStrong: '#dbd9d7',
      borderInverse: '#575655',
      borderSelected: '#9e9c9a',
      borderSelectedBrand: '#f36805',
      borderForm: '#8B8A88',
      dividerDefault: 'rgba(0,0,0,0.08)',
      dividerInverse: 'rgba(255,255,255,0.2)',
      interactiveBrand: '#f36805',
      interactivePrimary: '#262626',
      interactiveSecondary: '#f5f3f1',
      interactiveInverse: '#fff',
      interactiveLight: '#fff',
      interactiveForm: '#797876',
      interactiveError: '#d50525',
      overlay: 'rgba(0,0,0,0.55)',
      transparent: 'rgba(255,255,255,0)',
      supportError: '#d50525',
      supportWarning: '#f6c243',
      supportPositive: '#017a39',
      supportInfo: '#125fca',
      supportNeutral: '#efedea',
      supportError02: '#ffe9ea',
      supportWarning02: '#fff9df',
      supportPositive02: '#e5faef',
      supportInfo02: '#ebf6fa',
      supportInfoInverse: '#7aadf6',
      supportPositiveInverse: '#22bf65',
      supportNeutralPersistent: '#efedea',
      supportErrorInverse: '#e22c3e',
      supportWarningInverse: '#f6c243',
      supportBrand01: '#ff8000',
      supportBrand02: '#ffead4',
      supportBrand03: '#c1dade',
      supportBrand03Subtle: '#e7f4f6',
      supportBrand04: '#f2a6b0',
      supportBrand04Subtle: '#ffe7eb',
      supportBrand05: '#f6c243',
      supportBrand05Subtle: '#fff9de',
      supportBrand06: '#5b3d5b',
      supportBrand06Subtle: '#e7d6e7',
      supportBrand07: '#f75e28',
      supportBrand07Subtle: '#ffd3bf',
      contentDefault: '#242e30',
      contentSubdued: '#3c4c4f',
      contentInteractiveBrand: '#f36805',
      contentInteractiveLight: '#fff',
      contentInteractivePrimary: '#fff',
      contentInteractiveSecondary: '#242e30',
      contentInteractiveTertiary: '#303d3f',
      contentInteractiveSubdued: '#5d7074',
      contentInteractiveInverse: '#242e30',
      contentInteractiveDark: '#242e30',
      contentInteractiveError: '#d50525',
      contentLight: '#fff',
      contentDark: '#242e30',
      contentInverse: '#fff',
      contentLink: '#242e30',
      contentLinkDistinct: '#125fca',
      contentLinkLight: '#fff',
      contentLinkInverse: '#fff',
      contentLinkVisited: '#800080',
      contentLinkVisitedInverse: '#c58af9',
      contentError: '#d50525',
      contentPlaceholder: '#68797d',
      contentPositive: '#017a39',
      contentDisabled: '#8c999b',
      contentBrand: '#f36805',
      hover01: 0.04,
      hover01Dark: 0.04,
      hover02: 0.08,
      hover02Light: 0.08,
      active01: 0.12,
      active01Dark: 0.12,
      active02: 0.2,
      active02Light: 0.2,
      resting: 'rgba(255,255,255,0)',
      focusInner: '#fff',
      focusOuter: '#094dac',
      disabled01: '#efedea',
      disabled01Inverse: '#3b3a39',
      skeleton01: '#f5f3f1',
      skeleton02: '#efedea',
      skeleton03: '#fff',
      skeletonShimmer01: '#fcfcfc',
      skeletonShimmer02: '#fcfcfc',
      skeletonShimmer03: '#f5f3f1',
    },
    dark: {
      backgroundDefault: '#1a1a19',
      backgroundSubtle: '#3b3a39',
      backgroundDark: '#fff',
      containerDefault: '#262626',
      containerSubtle: '#3b3a39',
      containerStrong: '#575655',
      containerDark: '#262626',
      containerLight: '#fff',
      containerInverse: '#fff',
      containerInverseAlternative: '#575655',
      borderDefault: '#575655',
      borderSubtle: '#494847',
      borderStrong: '#797876',
      borderInverse: '#efedea',
      borderSelected: '#dbd9d7',
      borderSelectedBrand: '#f36805',
      borderForm: '#9e9c9a',
      dividerDefault: 'rgba(255,255,255,0.2)',
      dividerInverse: 'rgba(0,0,0,0.08)',
      interactiveBrand: '#f36805',
      interactivePrimary: '#fff',
      interactiveSecondary: '#494847',
      interactiveInverse: '#262626',
      interactiveLight: '#fff',
      interactiveForm: '#9e9c9a',
      interactiveError: '#e22c3e',
      overlay: 'rgba(0,0,0,0.55)',
      transparent: 'rgba(255,255,255,0)',
      supportError: '#e22c3e',
      supportWarning: '#f6c243',
      supportPositive: '#22bf65',
      supportInfo: '#7aadf6',
      supportNeutral: '#1a1a19',
      supportError02: '#491e24',
      supportWarning02: '#474630',
      supportPositive02: '#273f33',
      supportInfo02: '#083343',
      supportInfoInverse: '#125fca',
      supportPositiveInverse: '#017a39',
      supportNeutralPersistent: '#efedea',
      supportErrorInverse: '#d50525',
      supportWarningInverse: '#bf8b09',
      supportBrand01: '#ff8000',
      supportBrand02: '#41301f',
      supportBrand03: '#c1dade',
      supportBrand03Subtle: '#254043',
      supportBrand04: '#f2a6b0',
      supportBrand04Subtle: '#622d35',
      supportBrand05: '#f6c243',
      supportBrand05Subtle: '#745300',
      supportBrand06: '#5b3d5b',
      supportBrand06Subtle: '#452844',
      supportBrand07: '#f75e28',
      supportBrand07Subtle: '#622b18',
      contentDefault: '#fff',
      contentSubdued: '#d7d9da',
      contentInteractiveBrand: '#ff8000',
      contentInteractiveLight: '#fff',
      contentInteractivePrimary: '#242e30',
      contentInteractiveSecondary: '#fff',
      contentInteractiveTertiary: '#fff',
      contentInteractiveSubdued: '#b7bdbe',
      contentInteractiveInverse: '#fff',
      contentInteractiveDark: '#242e30',
      contentInteractiveError: '#f68179',
      contentLight: '#fff',
      contentDark: '#242e30',
      contentInverse: '#242e30',
      contentLink: '#fff',
      contentLinkDistinct: '#7aadf6',
      contentLinkLight: '#fff',
      contentLinkInverse: '#242e30',
      contentLinkVisited: '#c58af9',
      contentLinkVisitedInverse: '#800080',
      contentError: '#f68179',
      contentPlaceholder: '#8c999b',
      contentPositive: '#22bf65',
      contentDisabled: '#8c999b',
      contentBrand: '#ff8000',
      hover01: 0.08,
      hover01Dark: 0.04,
      hover02: 0.04,
      hover02Light: 0.08,
      active01: 0.2,
      active01Dark: 0.12,
      active02: 0.12,
      active02Light: 0.2,
      resting: 'rgba(0,0,0,0)',
      focusInner: '#000',
      focusOuter: '#7aadf6',
      disabled01: '#3b3a39',
      disabled01Inverse: '#efedea',
      skeleton01: '#3b3a39',
      skeleton02: '#494847',
      skeleton03: '#262626',
      skeletonShimmer01: '#494847',
      skeletonShimmer02: '#575655',
      skeletonShimmer03: '#3b3a39',
    },
    highcontrast: {
      backgroundDefault: '#fff',
      backgroundSubtle: '#fff',
      backgroundDark: '#000',
      containerDefault: '#fff',
      containerSubtle: '#fff',
      containerStrong: '#fff',
      containerDark: '#000',
      containerLight: '#fff',
      containerInverse: '#000',
      containerInverseAlternative: '#000',
      borderDefault: '#000',
      borderSubtle: '#000',
      borderStrong: '#000',
      borderInverse: '#fff',
      borderSelected: '#000',
      borderSelectedBrand: '#a33100',
      borderForm: '#000',
      dividerDefault: '#000',
      dividerInverse: '#fff',
      interactiveBrand: '#a33100',
      interactivePrimary: '#000',
      interactiveSecondary: '#fff',
      interactiveInverse: '#fff',
      interactiveLight: '#fff',
      interactiveForm: '#000',
      interactiveError: '#d50525',
      overlay: 'rgba(0,0,0,0.55)',
      transparent: 'rgba(255,255,255,0)',
      supportError: '#a4041f',
      supportWarning: '#685731',
      supportPositive: '#196634',
      supportInfo: '#1054b4',
      supportNeutral: '#fff',
      supportError02: '#fff',
      supportWarning02: '#fff',
      supportPositive02: '#fff',
      supportInfo02: '#fff',
      supportInfoInverse: '#8bbcfe',
      supportPositiveInverse: '#26d46e',
      supportNeutralPersistent: '#fff',
      supportErrorInverse: '#ff7a80',
      supportWarningInverse: '#f6c243',
      supportBrand01: '#ff8000',
      supportBrand02: '#fff',
      supportBrand03: '#fff',
      supportBrand03Subtle: '#e7f4f6',
      supportBrand04: '#fff',
      supportBrand04Subtle: '#ffe7eb',
      supportBrand05: '#fff',
      supportBrand05Subtle: '#fff9df',
      supportBrand06: '#fff',
      supportBrand06Subtle: '#e7d6e7',
      supportBrand07: '#fff',
      supportBrand07Subtle: '#ffd3bf',
      contentDefault: '#000',
      contentSubdued: '#000',
      contentInteractiveBrand: '#a33100',
      contentInteractiveLight: '#fff',
      contentInteractivePrimary: '#fff',
      contentInteractiveSecondary: '#000',
      contentInteractiveTertiary: '#000',
      contentInteractiveSubdued: '#000',
      contentInteractiveInverse: '#000',
      contentInteractiveDark: '#000',
      contentInteractiveError: '#a4041f',
      contentLight: '#fff',
      contentDark: '#000',
      contentInverse: '#fff',
      contentLink: '#000',
      contentLinkDistinct: '#125fca',
      contentLinkLight: '#fff',
      contentLinkInverse: '#fff',
      contentLinkVisited: '#800080',
      contentLinkVisitedInverse: '#c58af9',
      contentError: '#a4041f',
      contentPlaceholder: '#68797d',
      contentPositive: '#196634',
      contentDisabled: '#8c999b',
      contentBrand: '#a33100',
      hover01: 0.04,
      hover01Dark: 0.04,
      hover02: 0.08,
      hover02Light: 0.08,
      active01: 0.12,
      active01Dark: 0.12,
      active02: 0.2,
      active02Light: 0.2,
      resting: 'rgba(255,255,255,0)',
      focusInner: '#fff',
      focusOuter: '#094dac',
      disabled01: '#efedea',
      disabled01Inverse: '#3b3a39',
      skeleton01: '#f5f3f1',
      skeleton02: '#efedea',
      skeleton03: '#fff',
      skeletonShimmer01: '#fcfcfc',
      skeletonShimmer02: '#fcfcfc',
      skeletonShimmer03: '#f5f3f1',
    },
    highcontrastDark: {
      backgroundDefault: '#000',
      backgroundSubtle: '#000',
      backgroundDark: '#000',
      containerDefault: '#000',
      containerSubtle: '#000',
      containerStrong: '#000',
      containerDark: '#000',
      containerLight: '#fff',
      containerInverse: '#fff',
      containerInverseAlternative: '#000',
      borderDefault: '#fff',
      borderSubtle: '#fff',
      borderStrong: '#fff',
      borderInverse: '#000',
      borderSelected: '#fff',
      borderSelectedBrand: '#ff8000',
      borderForm: '#fff',
      dividerDefault: '#fff',
      dividerInverse: '#000',
      interactiveBrand: '#ff8000',
      interactivePrimary: '#fff',
      interactiveSecondary: '#000',
      interactiveInverse: '#000',
      interactiveLight: '#fff',
      interactiveForm: '#fff',
      interactiveError: '#e22c3e',
      overlay: 'rgba(0,0,0,0.55)',
      transparent: 'rgba(255,255,255,0)',
      supportError: '#ff7a80',
      supportWarning: '#f6c243',
      supportPositive: '#26d46e',
      supportInfo: '#8bbcfe',
      supportNeutral: '#000',
      supportError02: '#000',
      supportWarning02: '#000',
      supportPositive02: '#000',
      supportInfo02: '#000',
      supportInfoInverse: '#1054b4',
      supportPositiveInverse: '#196634',
      supportNeutralPersistent: '#000',
      supportErrorInverse: '#a4041f',
      supportWarningInverse: '#bf8b09',
      supportBrand01: '#ff8000',
      supportBrand02: '#000',
      supportBrand03: '#000',
      supportBrand03Subtle: '#254043',
      supportBrand04: '#000',
      supportBrand04Subtle: '#622d35',
      supportBrand05: '#000',
      supportBrand05Subtle: '#745300',
      supportBrand06: '#000',
      supportBrand06Subtle: '#452844',
      supportBrand07: '#000',
      supportBrand07Subtle: '#622b18',
      contentDefault: '#fff',
      contentSubdued: '#fff',
      contentInteractiveBrand: '#ff8000',
      contentInteractiveLight: '#fff',
      contentInteractivePrimary: '#000',
      contentInteractiveSecondary: '#fff',
      contentInteractiveTertiary: '#fff',
      contentInteractiveSubdued: '#fff',
      contentInteractiveInverse: '#fff',
      contentInteractiveDark: '#000',
      contentInteractiveError: '#ff7a80',
      contentLight: '#fff',
      contentDark: '#000',
      contentInverse: '#000',
      contentLink: '#fff',
      contentLinkDistinct: '#8bbcfe',
      contentLinkLight: '#fff',
      contentLinkInverse: '#000',
      contentLinkVisited: '#c58af9',
      contentLinkVisitedInverse: '#800080',
      contentError: '#ff7a80',
      contentPlaceholder: '#8c999b',
      contentPositive: '#26d46e',
      contentDisabled: '#8c999b',
      contentBrand: '#ff8000',
      hover01: 0.08,
      hover01Dark: 0.04,
      hover02: 0.04,
      hover02Light: 0.08,
      active01: 0.2,
      active01Dark: 0.12,
      active02: 0.12,
      active02Light: 0.2,
      resting: 'rgba(0,0,0,0)',
      focusInner: '#000',
      focusOuter: '#7aadf6',
      disabled01: '#3b3a39',
      disabled01Inverse: '#efedea',
      skeleton01: '#3b3a39',
      skeleton02: '#1a1a19',
      skeleton03: '#262626',
      skeletonShimmer01: '#494847',
      skeletonShimmer02: '#575655',
      skeletonShimmer03: '#3b3a39',
    },
  },
  spacing: {
    s10: '80px',
    s00: '0px',
    s01: '4px',
    s02: '8px',
    s03: '12px',
    s04: '16px',
    s05: '24px',
    s06: '32px',
    s07: '40px',
    s08: '56px',
    s09: '64px',
  },
  radius: {
    roundedNone: '0px',
    roundedA: '4px',
    roundedB: '8px',
    roundedC: '12px',
    roundedD: '16px',
    roundedE: '50rem',
  },
  elevation: {
    e1:
      '0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 2px 1px -1px rgba(0, 0, 0, 0.06), 0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    e2:
      '0 2px 2px 0 rgba(0, 0, 0, 0.07), 0 3px 1px -2px rgba(0, 0, 0, 0.06), 0 1px 5px 0 rgba(0, 0, 0, 0.1)',
    e3:
      '0 3px 4px 0 rgba(0, 0, 0, 0.07), 0 3px 3px -2px rgba(0, 0, 0, 0.06), 0 1px 8px 0 rgba(0, 0, 0, 0.1)',
    e4:
      '0 4px 5px 0 rgba(0, 0, 0, 0.07), 0 1px 10px 0 rgba(0, 0, 0, 0.06), 0 2px 4px -1px rgba(0, 0, 0, 0.1)',
    e5:
      '0 6px 10px 0 rgba(0, 0, 0, 0.07), 0 1px 18px 0 rgba(0, 0, 0, 0.06), 0 3px 5px -1px rgba(0, 0, 0, 0.1)',
    e6:
      '0 8px 10px 1px rgba(0, 0, 0, 0.07), 0 3px 14px 2px rgba(0, 0, 0, 0.06), 0 5px 5px -3px rgba(0, 0, 0, 0.1)',
    e7:
      '0 9px 12px 1px rgba(0, 0, 0, 0.07), 0 3px 16px 2px rgba(0, 0, 0, 0.06), 0 5px 6px -3px rgba(0, 0, 0, 0.1)',
    e8:
      '0 12px 17px 2px rgba(0, 0, 0, 0.07), 0 5px 22px 4px rgba(0, 0, 0, 0.06), 0 7px 8px -4px rgba(0, 0, 0, 0.1)',
    e9:
      '0 16px 24px 2px rgba(0, 0, 0, 0.07), 0 6px 30px 5px rgba(0, 0, 0, 0.06), 0 8px 10px -5px rgba(0, 0, 0, 0.1)',
    e10:
      '0 24px 38px 3px rgba(0, 0, 0, 0.07), 0 9px 46px 8px rgba(0, 0, 0, 0.06), 0 11px 15px -7px rgba(0, 0, 0, 0.1)',
  },
  motion: {
    speed: {
      defaultS: '200ms',
      exitS: '100ms',
      defaultM: '400ms',
      exitM: '250ms',
      defaultL: '600ms',
      exitL: '450ms',
    },
    easing: {
      easeDefault: 'cubic-bezier(0.5,0.2,0.4,1)',
      easeEmphasis: 'cubic-bezier(1,0.35,0.15,1)',
    },
  },
};

module.exports.skipTokensCssVariables = {
  global: {
    aubergine10: 'var(--aubergine-10)',
    aubergine80: 'var(--aubergine-80)',
    berry10: 'var(--berry-10)',
    berry90: 'var(--berry-90)',
    black: 'var(--black)',
    blue: 'var(--blue)',
    blue10: 'var(--blue-10)',
    blue25: 'var(--blue-25)',
    blue30: 'var(--blue-30)',
    blue70: 'var(--blue-70)',
    blue90: 'var(--blue-90)',
    blueDarkHc: 'var(--blue-dark-hc)',
    blueLightHc: 'var(--blue-light-hc)',
    charcoal30: 'var(--charcoal-30)',
    charcoal40: 'var(--charcoal-40)',
    charcoal50: 'var(--charcoal-50)',
    charcoal57: 'var(--charcoal-57)',
    charcoal60: 'var(--charcoal-60)',
    charcoal70: 'var(--charcoal-70)',
    charcoal75: 'var(--charcoal-75)',
    charcoal80: 'var(--charcoal-80)',
    cupcake10: 'var(--cupcake-10)',
    cupcake90: 'var(--cupcake-90)',
    green: 'var(--green)',
    green10: 'var(--green-10)',
    green30: 'var(--green-30)',
    green90: 'var(--green-90)',
    greenDarkHc: 'var(--green-dark-hc)',
    greenLightHc: 'var(--green-light-hc)',
    mozzarella10: 'var(--mozzarella-10)',
    mozzarella100: 'var(--mozzarella-100)',
    mozzarella20: 'var(--mozzarella-20)',
    mozzarella30: 'var(--mozzarella-30)',
    mozzarella5: 'var(--mozzarella-5)',
    mozzarella50: 'var(--mozzarella-50)',
    mozzarella55: 'var(--mozzarella-55)',
    mozzarella60: 'var(--mozzarella-60)',
    mozzarella70: 'var(--mozzarella-70)',
    mozzarella75: 'var(--mozzarella-75)',
    mozzarella80: 'var(--mozzarella-80)',
    mozzarella90: 'var(--mozzarella-90)',
    orange: 'var(--orange)',
    orange10: 'var(--orange-10)',
    orange30: 'var(--orange-30)',
    orange55: 'var(--orange-55)',
    orange90: 'var(--orange-90)',
    orangeDarkHc: 'var(--orange-dark-hc)',
    purple: 'var(--purple)',
    purpleLightHc: 'var(--purple-light-hc)',
    red: 'var(--red)',
    red10: 'var(--red-10)',
    red25: 'var(--red-25)',
    red30: 'var(--red-30)',
    red40: 'var(--red-40)',
    red90: 'var(--red-90)',
    redDarkHc: 'var(--red-dark-hc)',
    redLightHc: 'var(--red-light-hc)',
    systemPurple: 'var(--system-purple)',
    systemPurple10: 'var(--system-purple-10)',
    tomato5: 'var(--tomato-5)',
    tomato90: 'var(--tomato-90)',
    turmeric5: 'var(--turmeric-5)',
    turmeric60: 'var(--turmeric-60)',
    turmeric80: 'var(--turmeric-80)',
    white: 'var(--white)',
    yellow: 'var(--yellow)',
    yellow10: 'var(--yellow-10)',
    yellow90: 'var(--yellow-90)',
    yellowDarkHc: 'var(--yellow-dark-hc)',
  },
  font: {
    familyCode: 'var(--font-family-code)',
    familyPrimary: 'var(--font-family-primary)',
    familySecondary: 'var(--font-family-secondary)',
    paragraphSpacing01: 'var(--font-paragraph-spacing-01)',
    paragraphSpacing02: 'var(--font-paragraph-spacing-02)',
    paragraphSpacing03: 'var(--font-paragraph-spacing-03)',
    size12: {
      fontSize: 'var(--font-size-12-font-size)',
      lineHeight: 'var(--font-size-12-line-height)',
    },
    size14: {
      fontSize: 'var(--font-size-14-font-size)',
      lineHeight: 'var(--font-size-14-line-height)',
    },
    size16: {
      fontSize: 'var(--font-size-16-font-size)',
      lineHeight: 'var(--font-size-16-line-height)',
    },
    size20: {
      fontSize: 'var(--font-size-20-font-size)',
      lineHeight: 'var(--font-size-20-line-height)',
    },
    size24: {
      fontSize: 'var(--font-size-24-font-size)',
      lineHeight: 'var(--font-size-24-line-height)',
    },
    size28: {
      fontSize: 'var(--font-size-28-font-size)',
      lineHeight: 'var(--font-size-28-line-height)',
    },
    size32: {
      fontSize: 'var(--font-size-32-font-size)',
      lineHeight: 'var(--font-size-32-line-height)',
    },
    size48: {
      fontSize: 'var(--font-size-48-font-size)',
      lineHeight: 'var(--font-size-48-line-height)',
    },
    styleUnderline: 'var(--font-style-underline)',
    weightBold: 'var(--font-weight-bold)',
    weightExtrabold: 'var(--font-weight-extrabold)',
    weightRegular: 'var(--font-weight-regular)',
  },
  alias: {
    light: {
      backgroundDefault: 'var(--alias-light-background-default)',
      backgroundSubtle: 'var(--alias-light-background-subtle)',
      backgroundDark: 'var(--alias-light-background-dark)',
      containerDefault: 'var(--alias-light-container-default)',
      containerSubtle: 'var(--alias-light-container-subtle)',
      containerStrong: 'var(--alias-light-container-strong)',
      containerDark: 'var(--alias-light-container-dark)',
      containerLight: 'var(--alias-light-container-light)',
      containerInverse: 'var(--alias-light-container-inverse)',
      containerInverseAlternative: 'var(--alias-light-container-inverse-alternative)',
      borderDefault: 'var(--alias-light-border-default)',
      borderSubtle: 'var(--alias-light-border-subtle)',
      borderStrong: 'var(--alias-light-border-strong)',
      borderInverse: 'var(--alias-light-border-inverse)',
      borderSelected: 'var(--alias-light-border-selected)',
      borderSelectedBrand: 'var(--alias-light-border-selected-brand)',
      borderForm: 'var(--alias-light-border-form)',
      dividerDefault: 'var(--alias-light-divider-default)',
      dividerInverse: 'var(--alias-light-divider-inverse)',
      interactiveBrand: 'var(--alias-light-interactive-brand)',
      interactivePrimary: 'var(--alias-light-interactive-primary)',
      interactiveSecondary: 'var(--alias-light-interactive-secondary)',
      interactiveInverse: 'var(--alias-light-interactive-inverse)',
      interactiveLight: 'var(--alias-light-interactive-light)',
      interactiveForm: 'var(--alias-light-interactive-form)',
      interactiveError: 'var(--alias-light-interactive-error)',
      overlay: 'var(--alias-light-overlay)',
      transparent: 'var(--alias-light-transparent)',
      supportError: 'var(--alias-light-support-error)',
      supportWarning: 'var(--alias-light-support-warning)',
      supportPositive: 'var(--alias-light-support-positive)',
      supportInfo: 'var(--alias-light-support-info)',
      supportNeutral: 'var(--alias-light-support-neutral)',
      supportError02: 'var(--alias-light-support-error-02)',
      supportWarning02: 'var(--alias-light-support-warning-02)',
      supportPositive02: 'var(--alias-light-support-positive-02)',
      supportInfo02: 'var(--alias-light-support-info-02)',
      supportInfoInverse: 'var(--alias-light-support-info-inverse)',
      supportPositiveInverse: 'var(--alias-light-support-positive-inverse)',
      supportNeutralPersistent: 'var(--alias-light-support-neutral-persistent)',
      supportErrorInverse: 'var(--alias-light-support-error-inverse)',
      supportWarningInverse: 'var(--alias-light-support-warning-inverse)',
      supportBrand01: 'var(--alias-light-support-brand-01)',
      supportBrand02: 'var(--alias-light-support-brand-02)',
      supportBrand03: 'var(--alias-light-support-brand-03)',
      supportBrand03Subtle: 'var(--alias-light-support-brand-03-subtle)',
      supportBrand04: 'var(--alias-light-support-brand-04)',
      supportBrand04Subtle: 'var(--alias-light-support-brand-04-subtle)',
      supportBrand05: 'var(--alias-light-support-brand-05)',
      supportBrand05Subtle: 'var(--alias-light-support-brand-05-subtle)',
      supportBrand06: 'var(--alias-light-support-brand-06)',
      supportBrand06Subtle: 'var(--alias-light-support-brand-06-subtle)',
      supportBrand07: 'var(--alias-light-support-brand-07)',
      supportBrand07Subtle: 'var(--alias-light-support-brand-07-subtle)',
      contentDefault: 'var(--alias-light-content-default)',
      contentSubdued: 'var(--alias-light-content-subdued)',
      contentInteractiveBrand: 'var(--alias-light-content-interactive-brand)',
      contentInteractiveLight: 'var(--alias-light-content-interactive-light)',
      contentInteractivePrimary: 'var(--alias-light-content-interactive-primary)',
      contentInteractiveSecondary: 'var(--alias-light-content-interactive-secondary)',
      contentInteractiveTertiary: 'var(--alias-light-content-interactive-tertiary)',
      contentInteractiveSubdued: 'var(--alias-light-content-interactive-subdued)',
      contentInteractiveInverse: 'var(--alias-light-content-interactive-inverse)',
      contentInteractiveDark: 'var(--alias-light-content-interactive-dark)',
      contentInteractiveError: 'var(--alias-light-content-interactive-error)',
      contentLight: 'var(--alias-light-content-light)',
      contentDark: 'var(--alias-light-content-dark)',
      contentInverse: 'var(--alias-light-content-inverse)',
      contentLink: 'var(--alias-light-content-link)',
      contentLinkDistinct: 'var(--alias-light-content-link-distinct)',
      contentLinkLight: 'var(--alias-light-content-link-light)',
      contentLinkInverse: 'var(--alias-light-content-link-inverse)',
      contentLinkVisited: 'var(--alias-light-content-link-visited)',
      contentLinkVisitedInverse: 'var(--alias-light-content-link-visited-inverse)',
      contentError: 'var(--alias-light-content-error)',
      contentPlaceholder: 'var(--alias-light-content-placeholder)',
      contentPositive: 'var(--alias-light-content-positive)',
      contentDisabled: 'var(--alias-light-content-disabled)',
      contentBrand: 'var(--alias-light-content-brand)',
      hover01: 'var(--alias-light-hover-01)',
      hover01Dark: 'var(--alias-light-hover-01-dark)',
      hover02: 'var(--alias-light-hover-02)',
      hover02Light: 'var(--alias-light-hover-02-light)',
      active01: 'var(--alias-light-active-01)',
      active01Dark: 'var(--alias-light-active-01-dark)',
      active02: 'var(--alias-light-active-02)',
      active02Light: 'var(--alias-light-active-02-light)',
      resting: 'var(--alias-light-resting)',
      focusInner: 'var(--alias-light-focus-inner)',
      focusOuter: 'var(--alias-light-focus-outer)',
      disabled01: 'var(--alias-light-disabled-01)',
      disabled01Inverse: 'var(--alias-light-disabled-01-inverse)',
      skeleton01: 'var(--alias-light-skeleton-01)',
      skeleton02: 'var(--alias-light-skeleton-02)',
      skeleton03: 'var(--alias-light-skeleton-03)',
      skeletonShimmer01: 'var(--alias-light-skeleton-shimmer-01)',
      skeletonShimmer02: 'var(--alias-light-skeleton-shimmer-02)',
      skeletonShimmer03: 'var(--alias-light-skeleton-shimmer-03)',
    },
    dark: {
      backgroundDefault: 'var(--alias-dark-background-default)',
      backgroundSubtle: 'var(--alias-dark-background-subtle)',
      backgroundDark: 'var(--alias-dark-background-dark)',
      containerDefault: 'var(--alias-dark-container-default)',
      containerSubtle: 'var(--alias-dark-container-subtle)',
      containerStrong: 'var(--alias-dark-container-strong)',
      containerDark: 'var(--alias-dark-container-dark)',
      containerLight: 'var(--alias-dark-container-light)',
      containerInverse: 'var(--alias-dark-container-inverse)',
      containerInverseAlternative: 'var(--alias-dark-container-inverse-alternative)',
      borderDefault: 'var(--alias-dark-border-default)',
      borderSubtle: 'var(--alias-dark-border-subtle)',
      borderStrong: 'var(--alias-dark-border-strong)',
      borderInverse: 'var(--alias-dark-border-inverse)',
      borderSelected: 'var(--alias-dark-border-selected)',
      borderSelectedBrand: 'var(--alias-dark-border-selected-brand)',
      borderForm: 'var(--alias-dark-border-form)',
      dividerDefault: 'var(--alias-dark-divider-default)',
      dividerInverse: 'var(--alias-dark-divider-inverse)',
      interactiveBrand: 'var(--alias-dark-interactive-brand)',
      interactivePrimary: 'var(--alias-dark-interactive-primary)',
      interactiveSecondary: 'var(--alias-dark-interactive-secondary)',
      interactiveInverse: 'var(--alias-dark-interactive-inverse)',
      interactiveLight: 'var(--alias-dark-interactive-light)',
      interactiveForm: 'var(--alias-dark-interactive-form)',
      interactiveError: 'var(--alias-dark-interactive-error)',
      overlay: 'var(--alias-dark-overlay)',
      transparent: 'var(--alias-dark-transparent)',
      supportError: 'var(--alias-dark-support-error)',
      supportWarning: 'var(--alias-dark-support-warning)',
      supportPositive: 'var(--alias-dark-support-positive)',
      supportInfo: 'var(--alias-dark-support-info)',
      supportNeutral: 'var(--alias-dark-support-neutral)',
      supportError02: 'var(--alias-dark-support-error-02)',
      supportWarning02: 'var(--alias-dark-support-warning-02)',
      supportPositive02: 'var(--alias-dark-support-positive-02)',
      supportInfo02: 'var(--alias-dark-support-info-02)',
      supportInfoInverse: 'var(--alias-dark-support-info-inverse)',
      supportPositiveInverse: 'var(--alias-dark-support-positive-inverse)',
      supportNeutralPersistent: 'var(--alias-dark-support-neutral-persistent)',
      supportErrorInverse: 'var(--alias-dark-support-error-inverse)',
      supportWarningInverse: 'var(--alias-dark-support-warning-inverse)',
      supportBrand01: 'var(--alias-dark-support-brand-01)',
      supportBrand02: 'var(--alias-dark-support-brand-02)',
      supportBrand03: 'var(--alias-dark-support-brand-03)',
      supportBrand03Subtle: 'var(--alias-dark-support-brand-03-subtle)',
      supportBrand04: 'var(--alias-dark-support-brand-04)',
      supportBrand04Subtle: 'var(--alias-dark-support-brand-04-subtle)',
      supportBrand05: 'var(--alias-dark-support-brand-05)',
      supportBrand05Subtle: 'var(--alias-dark-support-brand-05-subtle)',
      supportBrand06: 'var(--alias-dark-support-brand-06)',
      supportBrand06Subtle: 'var(--alias-dark-support-brand-06-subtle)',
      supportBrand07: 'var(--alias-dark-support-brand-07)',
      supportBrand07Subtle: 'var(--alias-dark-support-brand-07-subtle)',
      contentDefault: 'var(--alias-dark-content-default)',
      contentSubdued: 'var(--alias-dark-content-subdued)',
      contentInteractiveBrand: 'var(--alias-dark-content-interactive-brand)',
      contentInteractiveLight: 'var(--alias-dark-content-interactive-light)',
      contentInteractivePrimary: 'var(--alias-dark-content-interactive-primary)',
      contentInteractiveSecondary: 'var(--alias-dark-content-interactive-secondary)',
      contentInteractiveTertiary: 'var(--alias-dark-content-interactive-tertiary)',
      contentInteractiveSubdued: 'var(--alias-dark-content-interactive-subdued)',
      contentInteractiveInverse: 'var(--alias-dark-content-interactive-inverse)',
      contentInteractiveDark: 'var(--alias-dark-content-interactive-dark)',
      contentInteractiveError: 'var(--alias-dark-content-interactive-error)',
      contentLight: 'var(--alias-dark-content-light)',
      contentDark: 'var(--alias-dark-content-dark)',
      contentInverse: 'var(--alias-dark-content-inverse)',
      contentLink: 'var(--alias-dark-content-link)',
      contentLinkDistinct: 'var(--alias-dark-content-link-distinct)',
      contentLinkLight: 'var(--alias-dark-content-link-light)',
      contentLinkInverse: 'var(--alias-dark-content-link-inverse)',
      contentLinkVisited: 'var(--alias-dark-content-link-visited)',
      contentLinkVisitedInverse: 'var(--alias-dark-content-link-visited-inverse)',
      contentError: 'var(--alias-dark-content-error)',
      contentPlaceholder: 'var(--alias-dark-content-placeholder)',
      contentPositive: 'var(--alias-dark-content-positive)',
      contentDisabled: 'var(--alias-dark-content-disabled)',
      contentBrand: 'var(--alias-dark-content-brand)',
      hover01: 'var(--alias-dark-hover-01)',
      hover01Dark: 'var(--alias-dark-hover-01-dark)',
      hover02: 'var(--alias-dark-hover-02)',
      hover02Light: 'var(--alias-dark-hover-02-light)',
      active01: 'var(--alias-dark-active-01)',
      active01Dark: 'var(--alias-dark-active-01-dark)',
      active02: 'var(--alias-dark-active-02)',
      active02Light: 'var(--alias-dark-active-02-light)',
      resting: 'var(--alias-dark-resting)',
      focusInner: 'var(--alias-dark-focus-inner)',
      focusOuter: 'var(--alias-dark-focus-outer)',
      disabled01: 'var(--alias-dark-disabled-01)',
      disabled01Inverse: 'var(--alias-dark-disabled-01-inverse)',
      skeleton01: 'var(--alias-dark-skeleton-01)',
      skeleton02: 'var(--alias-dark-skeleton-02)',
      skeleton03: 'var(--alias-dark-skeleton-03)',
      skeletonShimmer01: 'var(--alias-dark-skeleton-shimmer-01)',
      skeletonShimmer02: 'var(--alias-dark-skeleton-shimmer-02)',
      skeletonShimmer03: 'var(--alias-dark-skeleton-shimmer-03)',
    },
    highcontrast: {
      backgroundDefault: 'var(--alias-highcontrast-background-default)',
      backgroundSubtle: 'var(--alias-highcontrast-background-subtle)',
      backgroundDark: 'var(--alias-highcontrast-background-dark)',
      containerDefault: 'var(--alias-highcontrast-container-default)',
      containerSubtle: 'var(--alias-highcontrast-container-subtle)',
      containerStrong: 'var(--alias-highcontrast-container-strong)',
      containerDark: 'var(--alias-highcontrast-container-dark)',
      containerLight: 'var(--alias-highcontrast-container-light)',
      containerInverse: 'var(--alias-highcontrast-container-inverse)',
      containerInverseAlternative: 'var(--alias-highcontrast-container-inverse-alternative)',
      borderDefault: 'var(--alias-highcontrast-border-default)',
      borderSubtle: 'var(--alias-highcontrast-border-subtle)',
      borderStrong: 'var(--alias-highcontrast-border-strong)',
      borderInverse: 'var(--alias-highcontrast-border-inverse)',
      borderSelected: 'var(--alias-highcontrast-border-selected)',
      borderSelectedBrand: 'var(--alias-highcontrast-border-selected-brand)',
      borderForm: 'var(--alias-highcontrast-border-form)',
      dividerDefault: 'var(--alias-highcontrast-divider-default)',
      dividerInverse: 'var(--alias-highcontrast-divider-inverse)',
      interactiveBrand: 'var(--alias-highcontrast-interactive-brand)',
      interactivePrimary: 'var(--alias-highcontrast-interactive-primary)',
      interactiveSecondary: 'var(--alias-highcontrast-interactive-secondary)',
      interactiveInverse: 'var(--alias-highcontrast-interactive-inverse)',
      interactiveLight: 'var(--alias-highcontrast-interactive-light)',
      interactiveForm: 'var(--alias-highcontrast-interactive-form)',
      interactiveError: 'var(--alias-highcontrast-interactive-error)',
      overlay: 'var(--alias-highcontrast-overlay)',
      transparent: 'var(--alias-highcontrast-transparent)',
      supportError: 'var(--alias-highcontrast-support-error)',
      supportWarning: 'var(--alias-highcontrast-support-warning)',
      supportPositive: 'var(--alias-highcontrast-support-positive)',
      supportInfo: 'var(--alias-highcontrast-support-info)',
      supportNeutral: 'var(--alias-highcontrast-support-neutral)',
      supportError02: 'var(--alias-highcontrast-support-error-02)',
      supportWarning02: 'var(--alias-highcontrast-support-warning-02)',
      supportPositive02: 'var(--alias-highcontrast-support-positive-02)',
      supportInfo02: 'var(--alias-highcontrast-support-info-02)',
      supportInfoInverse: 'var(--alias-highcontrast-support-info-inverse)',
      supportPositiveInverse: 'var(--alias-highcontrast-support-positive-inverse)',
      supportNeutralPersistent: 'var(--alias-highcontrast-support-neutral-persistent)',
      supportErrorInverse: 'var(--alias-highcontrast-support-error-inverse)',
      supportWarningInverse: 'var(--alias-highcontrast-support-warning-inverse)',
      supportBrand01: 'var(--alias-highcontrast-support-brand-01)',
      supportBrand02: 'var(--alias-highcontrast-support-brand-02)',
      supportBrand03: 'var(--alias-highcontrast-support-brand-03)',
      supportBrand03Subtle: 'var(--alias-highcontrast-support-brand-03-subtle)',
      supportBrand04: 'var(--alias-highcontrast-support-brand-04)',
      supportBrand04Subtle: 'var(--alias-highcontrast-support-brand-04-subtle)',
      supportBrand05: 'var(--alias-highcontrast-support-brand-05)',
      supportBrand05Subtle: 'var(--alias-highcontrast-support-brand-05-subtle)',
      supportBrand06: 'var(--alias-highcontrast-support-brand-06)',
      supportBrand06Subtle: 'var(--alias-highcontrast-support-brand-06-subtle)',
      supportBrand07: 'var(--alias-highcontrast-support-brand-07)',
      supportBrand07Subtle: 'var(--alias-highcontrast-support-brand-07-subtle)',
      contentDefault: 'var(--alias-highcontrast-content-default)',
      contentSubdued: 'var(--alias-highcontrast-content-subdued)',
      contentInteractiveBrand: 'var(--alias-highcontrast-content-interactive-brand)',
      contentInteractiveLight: 'var(--alias-highcontrast-content-interactive-light)',
      contentInteractivePrimary: 'var(--alias-highcontrast-content-interactive-primary)',
      contentInteractiveSecondary: 'var(--alias-highcontrast-content-interactive-secondary)',
      contentInteractiveTertiary: 'var(--alias-highcontrast-content-interactive-tertiary)',
      contentInteractiveSubdued: 'var(--alias-highcontrast-content-interactive-subdued)',
      contentInteractiveInverse: 'var(--alias-highcontrast-content-interactive-inverse)',
      contentInteractiveDark: 'var(--alias-highcontrast-content-interactive-dark)',
      contentInteractiveError: 'var(--alias-highcontrast-content-interactive-error)',
      contentLight: 'var(--alias-highcontrast-content-light)',
      contentDark: 'var(--alias-highcontrast-content-dark)',
      contentInverse: 'var(--alias-highcontrast-content-inverse)',
      contentLink: 'var(--alias-highcontrast-content-link)',
      contentLinkDistinct: 'var(--alias-highcontrast-content-link-distinct)',
      contentLinkLight: 'var(--alias-highcontrast-content-link-light)',
      contentLinkInverse: 'var(--alias-highcontrast-content-link-inverse)',
      contentLinkVisited: 'var(--alias-highcontrast-content-link-visited)',
      contentLinkVisitedInverse: 'var(--alias-highcontrast-content-link-visited-inverse)',
      contentError: 'var(--alias-highcontrast-content-error)',
      contentPlaceholder: 'var(--alias-highcontrast-content-placeholder)',
      contentPositive: 'var(--alias-highcontrast-content-positive)',
      contentDisabled: 'var(--alias-highcontrast-content-disabled)',
      contentBrand: 'var(--alias-highcontrast-content-brand)',
      hover01: 'var(--alias-highcontrast-hover-01)',
      hover01Dark: 'var(--alias-highcontrast-hover-01-dark)',
      hover02: 'var(--alias-highcontrast-hover-02)',
      hover02Light: 'var(--alias-highcontrast-hover-02-light)',
      active01: 'var(--alias-highcontrast-active-01)',
      active01Dark: 'var(--alias-highcontrast-active-01-dark)',
      active02: 'var(--alias-highcontrast-active-02)',
      active02Light: 'var(--alias-highcontrast-active-02-light)',
      resting: 'var(--alias-highcontrast-resting)',
      focusInner: 'var(--alias-highcontrast-focus-inner)',
      focusOuter: 'var(--alias-highcontrast-focus-outer)',
      disabled01: 'var(--alias-highcontrast-disabled-01)',
      disabled01Inverse: 'var(--alias-highcontrast-disabled-01-inverse)',
      skeleton01: 'var(--alias-highcontrast-skeleton-01)',
      skeleton02: 'var(--alias-highcontrast-skeleton-02)',
      skeleton03: 'var(--alias-highcontrast-skeleton-03)',
      skeletonShimmer01: 'var(--alias-highcontrast-skeleton-shimmer-01)',
      skeletonShimmer02: 'var(--alias-highcontrast-skeleton-shimmer-02)',
      skeletonShimmer03: 'var(--alias-highcontrast-skeleton-shimmer-03)',
    },
    highcontrastDark: {
      backgroundDefault: 'var(--alias-highcontrast-dark-background-default)',
      backgroundSubtle: 'var(--alias-highcontrast-dark-background-subtle)',
      backgroundDark: 'var(--alias-highcontrast-dark-background-dark)',
      containerDefault: 'var(--alias-highcontrast-dark-container-default)',
      containerSubtle: 'var(--alias-highcontrast-dark-container-subtle)',
      containerStrong: 'var(--alias-highcontrast-dark-container-strong)',
      containerDark: 'var(--alias-highcontrast-dark-container-dark)',
      containerLight: 'var(--alias-highcontrast-dark-container-light)',
      containerInverse: 'var(--alias-highcontrast-dark-container-inverse)',
      containerInverseAlternative: 'var(--alias-highcontrast-dark-container-inverse-alternative)',
      borderDefault: 'var(--alias-highcontrast-dark-border-default)',
      borderSubtle: 'var(--alias-highcontrast-dark-border-subtle)',
      borderStrong: 'var(--alias-highcontrast-dark-border-strong)',
      borderInverse: 'var(--alias-highcontrast-dark-border-inverse)',
      borderSelected: 'var(--alias-highcontrast-dark-border-selected)',
      borderSelectedBrand: 'var(--alias-highcontrast-dark-border-selected-brand)',
      borderForm: 'var(--alias-highcontrast-dark-border-form)',
      dividerDefault: 'var(--alias-highcontrast-dark-divider-default)',
      dividerInverse: 'var(--alias-highcontrast-dark-divider-inverse)',
      interactiveBrand: 'var(--alias-highcontrast-dark-interactive-brand)',
      interactivePrimary: 'var(--alias-highcontrast-dark-interactive-primary)',
      interactiveSecondary: 'var(--alias-highcontrast-dark-interactive-secondary)',
      interactiveInverse: 'var(--alias-highcontrast-dark-interactive-inverse)',
      interactiveLight: 'var(--alias-highcontrast-dark-interactive-light)',
      interactiveForm: 'var(--alias-highcontrast-dark-interactive-form)',
      interactiveError: 'var(--alias-highcontrast-dark-interactive-error)',
      overlay: 'var(--alias-highcontrast-dark-overlay)',
      transparent: 'var(--alias-highcontrast-dark-transparent)',
      supportError: 'var(--alias-highcontrast-dark-support-error)',
      supportWarning: 'var(--alias-highcontrast-dark-support-warning)',
      supportPositive: 'var(--alias-highcontrast-dark-support-positive)',
      supportInfo: 'var(--alias-highcontrast-dark-support-info)',
      supportNeutral: 'var(--alias-highcontrast-dark-support-neutral)',
      supportError02: 'var(--alias-highcontrast-dark-support-error-02)',
      supportWarning02: 'var(--alias-highcontrast-dark-support-warning-02)',
      supportPositive02: 'var(--alias-highcontrast-dark-support-positive-02)',
      supportInfo02: 'var(--alias-highcontrast-dark-support-info-02)',
      supportInfoInverse: 'var(--alias-highcontrast-dark-support-info-inverse)',
      supportPositiveInverse: 'var(--alias-highcontrast-dark-support-positive-inverse)',
      supportNeutralPersistent: 'var(--alias-highcontrast-dark-support-neutral-persistent)',
      supportErrorInverse: 'var(--alias-highcontrast-dark-support-error-inverse)',
      supportWarningInverse: 'var(--alias-highcontrast-dark-support-warning-inverse)',
      supportBrand01: 'var(--alias-highcontrast-dark-support-brand-01)',
      supportBrand02: 'var(--alias-highcontrast-dark-support-brand-02)',
      supportBrand03: 'var(--alias-highcontrast-dark-support-brand-03)',
      supportBrand03Subtle: 'var(--alias-highcontrast-dark-support-brand-03-subtle)',
      supportBrand04: 'var(--alias-highcontrast-dark-support-brand-04)',
      supportBrand04Subtle: 'var(--alias-highcontrast-dark-support-brand-04-subtle)',
      supportBrand05: 'var(--alias-highcontrast-dark-support-brand-05)',
      supportBrand05Subtle: 'var(--alias-highcontrast-dark-support-brand-05-subtle)',
      supportBrand06: 'var(--alias-highcontrast-dark-support-brand-06)',
      supportBrand06Subtle: 'var(--alias-highcontrast-dark-support-brand-06-subtle)',
      supportBrand07: 'var(--alias-highcontrast-dark-support-brand-07)',
      supportBrand07Subtle: 'var(--alias-highcontrast-dark-support-brand-07-subtle)',
      contentDefault: 'var(--alias-highcontrast-dark-content-default)',
      contentSubdued: 'var(--alias-highcontrast-dark-content-subdued)',
      contentInteractiveBrand: 'var(--alias-highcontrast-dark-content-interactive-brand)',
      contentInteractiveLight: 'var(--alias-highcontrast-dark-content-interactive-light)',
      contentInteractivePrimary: 'var(--alias-highcontrast-dark-content-interactive-primary)',
      contentInteractiveSecondary: 'var(--alias-highcontrast-dark-content-interactive-secondary)',
      contentInteractiveTertiary: 'var(--alias-highcontrast-dark-content-interactive-tertiary)',
      contentInteractiveSubdued: 'var(--alias-highcontrast-dark-content-interactive-subdued)',
      contentInteractiveInverse: 'var(--alias-highcontrast-dark-content-interactive-inverse)',
      contentInteractiveDark: 'var(--alias-highcontrast-dark-content-interactive-dark)',
      contentInteractiveError: 'var(--alias-highcontrast-dark-content-interactive-error)',
      contentLight: 'var(--alias-highcontrast-dark-content-light)',
      contentDark: 'var(--alias-highcontrast-dark-content-dark)',
      contentInverse: 'var(--alias-highcontrast-dark-content-inverse)',
      contentLink: 'var(--alias-highcontrast-dark-content-link)',
      contentLinkDistinct: 'var(--alias-highcontrast-dark-content-link-distinct)',
      contentLinkLight: 'var(--alias-highcontrast-dark-content-link-light)',
      contentLinkInverse: 'var(--alias-highcontrast-dark-content-link-inverse)',
      contentLinkVisited: 'var(--alias-highcontrast-dark-content-link-visited)',
      contentLinkVisitedInverse: 'var(--alias-highcontrast-dark-content-link-visited-inverse)',
      contentError: 'var(--alias-highcontrast-dark-content-error)',
      contentPlaceholder: 'var(--alias-highcontrast-dark-content-placeholder)',
      contentPositive: 'var(--alias-highcontrast-dark-content-positive)',
      contentDisabled: 'var(--alias-highcontrast-dark-content-disabled)',
      contentBrand: 'var(--alias-highcontrast-dark-content-brand)',
      hover01: 'var(--alias-highcontrast-dark-hover-01)',
      hover01Dark: 'var(--alias-highcontrast-dark-hover-01-dark)',
      hover02: 'var(--alias-highcontrast-dark-hover-02)',
      hover02Light: 'var(--alias-highcontrast-dark-hover-02-light)',
      active01: 'var(--alias-highcontrast-dark-active-01)',
      active01Dark: 'var(--alias-highcontrast-dark-active-01-dark)',
      active02: 'var(--alias-highcontrast-dark-active-02)',
      active02Light: 'var(--alias-highcontrast-dark-active-02-light)',
      resting: 'var(--alias-highcontrast-dark-resting)',
      focusInner: 'var(--alias-highcontrast-dark-focus-inner)',
      focusOuter: 'var(--alias-highcontrast-dark-focus-outer)',
      disabled01: 'var(--alias-highcontrast-dark-disabled-01)',
      disabled01Inverse: 'var(--alias-highcontrast-dark-disabled-01-inverse)',
      skeleton01: 'var(--alias-highcontrast-dark-skeleton-01)',
      skeleton02: 'var(--alias-highcontrast-dark-skeleton-02)',
      skeleton03: 'var(--alias-highcontrast-dark-skeleton-03)',
      skeletonShimmer01: 'var(--alias-highcontrast-dark-skeleton-shimmer-01)',
      skeletonShimmer02: 'var(--alias-highcontrast-dark-skeleton-shimmer-02)',
      skeletonShimmer03: 'var(--alias-highcontrast-dark-skeleton-shimmer-03)',
    },
  },
  spacing: {
    s10: 'var(--spacing-10)',
    s00: 'var(--spacing-00)',
    s01: 'var(--spacing-01)',
    s02: 'var(--spacing-02)',
    s03: 'var(--spacing-03)',
    s04: 'var(--spacing-04)',
    s05: 'var(--spacing-05)',
    s06: 'var(--spacing-06)',
    s07: 'var(--spacing-07)',
    s08: 'var(--spacing-08)',
    s09: 'var(--spacing-09)',
  },
  radius: {
    roundedNone: 'var(--radius-rounded-none)',
    roundedA: 'var(--radius-rounded-a)',
    roundedB: 'var(--radius-rounded-b)',
    roundedC: 'var(--radius-rounded-c)',
    roundedD: 'var(--radius-rounded-d)',
    roundedE: 'var(--radius-rounded-e)',
  },
  elevation: {
    e1: 'var(--elevation-e-1)',
    e2: 'var(--elevation-e-2)',
    e3: 'var(--elevation-e-3)',
    e4: 'var(--elevation-e-4)',
    e5: 'var(--elevation-e-5)',
    e6: 'var(--elevation-e-6)',
    e7: 'var(--elevation-e-7)',
    e8: 'var(--elevation-e-8)',
    e9: 'var(--elevation-e-9)',
    e10: 'var(--elevation-e-10)',
  },
  motion: {
    speed: {
      defaultS: 'var(--motion-speed-default-s)',
      exitS: 'var(--motion-speed-exit-s)',
      defaultM: 'var(--motion-speed-default-m)',
      exitM: 'var(--motion-speed-exit-m)',
      defaultL: 'var(--motion-speed-default-l)',
      exitL: 'var(--motion-speed-exit-l)',
    },
    easing: {
      easeDefault: 'var(--motion-easing-ease-default)',
      easeEmphasis: 'var(--motion-easing-ease-emphasis)',
    },
  },
};
